<script>
import Layout from '@layouts/main.vue'
import popupPreview from '@utils/popup-preview.js'
import ApplinkPopup from '@components/applink-popup.vue'

export default {
  metaInfo: {
    title: '施設住所表示 | JAFナビ',
    meta: [{ name: 'description', content: '施設住所表示' }],
  },
  components: { Layout, ApplinkPopup },
  data() {
    return {
      lat: 35.681167,
      lng: 139.767052,
      MEISYO: '',
      map: null,
      showApplink: false,
    }
  },
  mounted() {
    // TODO: customer_id : localStorage.getItem('customerID')
    window.dataLayer.push({
      event: 'Webview',
      ap_screen_name: 'JAFナビ_施設詳細_施設住所表示',

      ap_member_id: this.$store.state.auth.memberNo,
      ap_member_type: localStorage.getItem('userType'),
    })
    this.$store.dispatch('layout/startLoading')
    this.lat = sessionStorage.getItem('DETAIL_LAT')
    this.lng = sessionStorage.getItem('DETAIL_LON')
    this.MEISYO = sessionStorage.getItem('MEISYO')

    this.window_size_set()
    this.$store.dispatch('layout/disableFocusHide')
    setTimeout(() => {
      if (this.$store.state.env.mapboxAccessToken.length > 0) {
        this.initMap()
      } else {
        setTimeout(this.initMap(), 500)
      }
    }, 200)
  },
  methods: {
    initMap: function () {
      mapboxgl.accessToken = this.$store.state.env.mapboxAccessToken

      this.map = new mapboxgl.Map({
        container: 'map',
        style: this.$store.state.env.mapboxStyle,
        center: [Number(this.lng), Number(this.lat)],
        zoom: 15,
      })

      // var nav = new mapboxgl.NavigationControl()
      // this.map.addControl(nav, 'top-left')

      var el = document.createElement('div')
      el.style.width = '19px'
      el.style.height = '26px'
      el.style.backgroundImage =
        "url('" + this.$store.state.env.basepath + "img/yahooMarkerIcon.png')"

      var marker = new mapboxgl.Marker(el)
        .setLngLat([Number(this.lng), Number(this.lat)])
        .addTo(this.map)

      var elements = document.getElementsByClassName('mapboxgl-canvas')
      if (elements.length > 0) {
        elements[0].removeAttribute('tabindex')
      }

      this.$store.dispatch('layout/endLoading')
    },
    window_size_set: function () {
      var headHeight = document.getElementById('head').offsetHeight
      var bottomHeight = document.getElementById('bottomButtonArea')
        .offsetHeight

      var winW = window.innerWidth
      var winH = 0
      if (winW <= 560) {
        winH = window.innerHeight - (headHeight + bottomHeight)
      } else {
        winH = window.innerHeight - 202
      }
      var element = document.getElementById('map')
      element.style.height = winH + 'px'
    },
    backHandler() {
      this.$store.dispatch('layout/enableFocusHide')
      this.$router.go(-1)
    },
    openApplink() {
      if (this.$store.state.coupons.preview !== '') {
        popupPreview()
      } else {
        sessionStorage.setItem('LAT', this.lat)
        sessionStorage.setItem('LON', this.lng)
        sessionStorage.setItem('MEISYO', this.MEISYO)
        this.showApplink = true
        window.dataLayer.push({
          event: '道案内手段選択',
          ap_screen_name: 'JAFナビ_地図表示_案内手段選択',
        })
        this.$store.dispatch('layout/hideTabbar')
      }
    },
    cancelApplink() {
      this.showApplink = false
      this.$store.dispatch('layout/showTabbar')
    },
  },
}
</script>

<template>
  <Layout>
    <div id="all_wrapper">
      <div id="app">
        <div id="su09_contents">
          <div id="map_area">
            <!-- 地図部分 -->
            <div class="map_cover content_limit_cover">
              <div id="map"> </div>
            </div>

            <div
              class="bottom_btn_area content_limit_cover"
              id="bottomButtonArea"
            >
              <div class="left">
                <a class="button" @click="backHandler">
                  <span class="text">＜施設詳細に戻る</span>
                </a>
              </div>

              <div class="right rightPut">
                <a class="button" @click="openApplink"
                  ><span class="text">道案内・カーナビ連携</span></a
                >
              </div>
            </div>
          </div>
        </div>

        <ApplinkPopup
          :show="showApplink"
          :lat="this.lat"
          :lon="this.lng"
          :name="this.MEISYO"
          @cancel="cancelApplink"
        ></ApplinkPopup>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
// @import '@design';
// @import '@assets/css/common.scss';
</style>
<style lang="scss" scoped>
@import '@assets/css/SU-09.scss';

#map {
  top: 0;
  z-index: 1;
  width: 100%;
  height: calc(100vh - 270px);
}

@media screen and (max-width: 560px) {
  #map {
    top: 0;
    height: calc(100vh - 103px);
  }
}
.yolp-ymapbanner {
  display: none !important;
}
</style>
